<template>
  <div class="edit">
    <div class="row">
      <span class="lbl">Image URL</span>
      <input v-model="local.image" class="in full" placeholder="https://…" @input="$emit('dirty')" />
    </div>
    <div class="row">
      <span class="lbl">Website</span>
      <input v-model="local.website" class="in full" placeholder="https://…" @input="$emit('dirty')" />
    </div>
    <div class="row">
      <span class="lbl">Twitter</span>
      <input v-model="local.twitter" class="in full" placeholder="https://twitter.com/…" @input="$emit('dirty')" />
    </div>
    <div class="row">
      <span class="lbl">Telegram</span>
      <input v-model="local.telegram" class="in full" placeholder="https://t.me/…" @input="$emit('dirty')" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  local: { type: Object, required: true },
})

defineEmits(['dirty'])
</script>

<style scoped>
.edit{ display:flex; flex-direction:column; gap:6px; margin-top:4px; }

.row{ display:flex; align-items:center; gap:6px; }
.lbl{ font-size:11px; color:#6b7280; min-width:70px; }

.in{
  background:transparent;
  border:1px solid transparent;
  border-radius:4px;
  padding:2px 4px;
  font-size:13px;
  color:#e5e7eb;
  min-width:0;
}
.in.full{ width:100%; }
.in::placeholder{ color:#4b5563; }
.in:focus{ outline:none; border-color:#4b5563; background:#020617; }
</style>
